import { render, staticRenderFns } from "./ChannelMenu.vue?vue&type=template&id=dcd84938&"
import script from "./ChannelMenu.vue?vue&type=script&lang=js&"
export * from "./ChannelMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports